import { lazy, Suspense } from 'react'
import { Hero } from '@/components/Hero'
import { Navigation } from '@/components/Navigation'
import { StructuredData } from '@/components/StructuredData'

const Portfolio = lazy(() => import('@/components/Portfolio').then(m => ({ default: m.Portfolio })))
const Awards = lazy(() => import('@/components/Awards').then(m => ({ default: m.Awards })))
const About = lazy(() => import('@/components/About').then(m => ({ default: m.About })))
const Services = lazy(() => import('@/components/Services').then(m => ({ default: m.Services })))
const ProjectSection = lazy(() => import('@/components/ProjectSection').then(m => ({ default: m.ProjectSection })))
const Contact = lazy(() => import('@/components/Contact').then(m => ({ default: m.Contact })))
const Footer = lazy(() => import('@/components/Footer').then(m => ({ default: m.Footer })))

function LoadingFallback() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background text-foreground" style={{ overflow: 'visible' }}>
      <StructuredData type="website" />
      <Navigation isHomePage={true} />
      
      <main className="relative" role="main" style={{ overflow: 'visible' }}>
        <section id="hero" aria-label="Hero section">
          <Hero />
        </section>
        
        <Suspense fallback={<LoadingFallback />}>
          <section id="portfolio" aria-label="About Me section">
            <Portfolio />
          </section>
          <section id="awards" aria-label="Social section">
            <Awards />
          </section>
          <section id="about" aria-label="About section">
            <About />
          </section>
          <section id="services" aria-label="Services section">
            <Services />
          </section>
          <section id="trauma" aria-label="创伤及天赋 section">
            <ProjectSection categoryId="trauma" />
          </section>
          <section id="large100" aria-label="Large 100 section">
            <ProjectSection categoryId="large100" />
          </section>
          <section id="launch100" aria-label="Launch 100 section">
            <ProjectSection categoryId="launch100" />
          </section>
          <section id="spy100" aria-label="Spy 100 section">
            <ProjectSection categoryId="spy100" />
          </section>
          <section id="ship100" aria-label="Ship 100 section">
            <ProjectSection categoryId="ship100" />
          </section>
          <section id="grow100" aria-label="Grow 100 section">
            <ProjectSection categoryId="grow100" />
          </section>
          <section id="contact" aria-label="Contact section">
            <Contact />
          </section>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  )
}
